import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

type Props = {
    name: string | null | undefined;
    htmlUrlPath: string | null | undefined;
    primaryPhoneNumber: string | null | undefined;
    primaryEmailAddress: string | null | undefined;
};

function getParticipantName(name?: string | null, primaryPhoneNumber?: string | null) {
    if (name) {
        return name;
    }

    if (primaryPhoneNumber) {
        return 'Unknown number';
    }

    return 'Unknown attendee';
}

export function Participant(props: Props) {
    const name = getParticipantName(props.name, props.primaryPhoneNumber);
    const secondaryInfo = props.primaryPhoneNumber || props.primaryEmailAddress;

    return (
        <Stack spacing={0}>
            {props.htmlUrlPath ? (
                // @ts-expect-error
                <Link variant='primary' as={RoutedLink} to={props.htmlUrlPath} size='small'>
                    {name}
                </Link>
            ) : (
                <Body size='small' wrapAnywhere={true}>
                    {name}
                </Body>
            )}
            {secondaryInfo && (
                <Body size='small' wrapAnywhere={true} color='light'>
                    {secondaryInfo}
                </Body>
            )}
        </Stack>
    );
}
